import { render } from "./logincompany.vue?vue&type=template&id=5e6bb54f"
import script from "./logincompany.vue?vue&type=script&lang=js"
export * from "./logincompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__